import { Component, inject } from '@angular/core';
import { FeUtil } from '../../../hezky-routes';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-account-disable',
    template: `
    <div class="flex flex-col items-center justify-center">
        <ng-container *ngIf="!modalData.data.isSystem">
            <nz-result nzStatus="error" nzTitle="Account Temporarily Disabled!">
                <div nz-result-extra>
                    Your password was last updated {{ expiryDate }} days ago. Please update your password to continue.
                </div>
            </nz-result>
        </ng-container>
        <ng-container *ngIf="modalData.data.isSystem">
            <nz-result 
                nzStatus="info" 
                nzTitle="Set a New Password for Security">
                <div nz-result-extra>
                    You're logging in with a temporary password.<br>
                    Please set up your own password to keep your account safe.
                </div>
            </nz-result>
        </ng-container>
        <button nz-button nzType="primary" type="button" (click)="updatePassword()" class="flex items-center">
            <span>Update Password</span>
            <span nz-icon nzType="arrow-right"></span>
        </button>
    </div>
`,
})
export class AccountDisableComponent {
    expiryDate: number = 0;
    readonly modalData: { data: { expiryDate: number, loginData: any, isSystem: boolean } } = inject(NZ_MODAL_DATA);
    constructor(private feUtil: FeUtil, private modal: NzModalRef) {
        this.expiryDate = this.modalData?.data?.expiryDate || 0;
        console.log(this.modalData.data.isSystem);
    }
    updatePassword(): void {
        this.modal.destroy();
        this.feUtil.router.navigate(['/auth/update-password'], { state: { loginData: this.modalData?.data?.loginData } });
    }
}
